@if (translationsReady) {
  <div class="container-fluid p-3">
    <span class="m-0 subheadText">{{ pieChartTitle | translate }}</span>
    <div class="padding-container py-2">
      <div [id]="pieChartId" class="divPieChart"></div>
      @if (noDataOnChart) {
        <p>{{ 'STATISTICS.NO_CHART_DATA' | translate }}</p>
      }
    </div>
  </div>
}
